import React from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import Page from '../../../component/page'
import Scorecard from './Scorecard'
import ScorecardModel from '../../../js/model/scorecard'

function GameScorecard({ games = [], courses = [], players = [] }) {
  const params = useParams()
  const renderLoading = () => (
    <Page className="container">
      <div className="row">
        <h1>Scorecard Loading...</h1>
      </div>
    </Page>
  )

  // TODO Handle share UUID (shared games)
  // Show PageNotFound on invalid gameId
  const { gameId } = params

  const game = games.find((g) => g.id == gameId) // eslint-disable-line eqeqeq
  if (!game) return renderLoading()

  const course = courses.find((c) => c.id === game.courseId)
  if (!course) return renderLoading()

  const scorecardPlayers = game.results.map((round) =>
    players.find((p) => p.id === round.playerId)
  )
  if (!scorecardPlayers) return renderLoading()

  const scorecard = new ScorecardModel(game, course, scorecardPlayers)
  console.log('Render GameScorecard', scorecard)

  return (
    <Page className="game">
      <div className="container">
        <div className="row">
          <h1>Scorecard</h1>
          <Scorecard scorecard={scorecard} />
        </div>
      </div>
    </Page>
  )
}

const mapStateToProps = (state) => {
  const { games, courses, players } = state.user.data || {}
  return {
    games: games || [],
    courses: courses || [],
    players: players || [],
  }
}

export default connect(mapStateToProps)(GameScorecard)
